import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import ModalModal from '../../common/components/ModalModal';
import LinkButton from 'flarum/common/components/LinkButton';
export default class ForumModalModal extends ModalModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "dismissed", false);
  }
  dismiss() {
    if (this.dismissed) return;
    this.dismissed = true;
    const modal = this.attrs.modal;
    const user = app.session.user;
    if (!user) return;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + `/modals/${modal.id()}/dismiss`
    });
  }
  onremove(vnode) {
    this.dismiss();
    return super.onremove(vnode);
  }
  hide() {
    this.dismiss();
    super.hide();
  }
  callToActionButton() {
    const label = this.attrs.modal.ctaLabel();
    const href = this.attrs.modal.ctaHref();
    if (!label || !href) return null;
    const isExternal = href.toLowerCase().startsWith('http');
    const target = this.attrs.modal.ctaTarget();
    if (isExternal || target !== '_self') {
      return m(LinkButton, {
        className: "Button Button--primary",
        href: href,
        external: isExternal,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        onclick: () => {
          this.hide();
        }
      }, label);
    }
    const path = href.startsWith('/') ? href : `/${href}`;
    const baseURL = app.forum.attribute('baseUrl');
    return m(LinkButton, {
      className: "Button Button--primary",
      href: baseURL + path,
      onclick: e => {
        e.preventDefault();
        this.hide();
        m.route.set(path);
      }
    }, label);
  }
}
flarum.reg.add('glowingblue-modals', 'forum/components/ForumModalModal', ForumModalModal);